import { gql } from '@apollo/client'

import { SUBSCRIPTION_INFO_FRAGMENT } from '../fragments'

export const ACTIVE_SUBSCRIPTION = gql`
  query ActiveSubscription {
    activeSubscription {
      ...SubscriptionInfo
    }
  }
  ${SUBSCRIPTION_INFO_FRAGMENT}
`
